import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Anchor, Text } from 'xen-ui';
import { SUPPORT_EMAIL } from 'xen/constants';
import { formatCase } from 'xen/helpers';
import { Page } from '../page';
import { PageTitle } from '../page-title';
export const FeatureNotEnabled = ({ feature }) => {
    return (_jsxs(Page, { "data-testid": `${formatCase.kebab(feature)}-not-enabled`, children: [_jsx(PageTitle, { title: "404: Feature not enabled" }), _jsxs(Text, { children: ["The ", _jsx("b", { children: feature }), " feature is not enabled. Contact", ' ', _jsx(Anchor, { href: `mailto:${SUPPORT_EMAIL}`, underline: "always", children: SUPPORT_EMAIL }), ' ', "for more information."] })] }));
};
